import { Typography } from 'antd';
import type { TextProps } from 'antd/es/typography/Text';
import type { FC } from 'react';

interface BatchLabelProps {
  type?: string;
  className?: string;
  children: TextProps['children'];
}

const BatchLabel: FC<BatchLabelProps> = ({ children, type, className }) => {
  return (
    <Typography.Text className={`custom-badge background-statusColor ${type || ''} ${className || ''}`}>
      {children}
    </Typography.Text>
  );
};

export default BatchLabel;
